import InformationSolid from '@simplywallst/ui-core/icons/InformationSolid';
import TableSolid from '@simplywallst/ui-core/icons/TableSolid';
import { ToggleButton, Button } from '@simplywallst/ui-core';
import { Feedback } from '../CompanyFeeds/Feedback';
import type { Visibility } from './styled';
import { ChartBottomWrapper } from './styled';

const MARKET_PERFORMANCE_CHART_FEEDBACK_FORM_ID = 'NlCweWZh';

interface Props {
  tableVisibility: Visibility;
  isButtonDisabled: boolean;
  toggleTableVisibility: () => void;
  openLearnMoreModal: () => void;
}
const ChartBottom = ({
  tableVisibility,
  isButtonDisabled,
  toggleTableVisibility,
  openLearnMoreModal,
}: Props) => {
  return (
    <ChartBottomWrapper justifyContent="flex-end" alignItem="center">
      <ToggleButton
        data-cy-id="market-performance-data-table-btn"
        styleType="subtle"
        alignIcon="right"
        state={tableVisibility === 'hidden' ? 'off' : 'on'}
        disabled={isButtonDisabled}
        onClick={toggleTableVisibility}
      >
        <TableSolid />
        Data
      </ToggleButton>
      <Button
        data-cy-id="market-performance-learn-more-modal-btn"
        styleType="passive"
        alignIcon="right"
        disabled={isButtonDisabled}
        onClick={openLearnMoreModal}
      >
        <InformationSolid /> Learn
      </Button>
      <Feedback formId={MARKET_PERFORMANCE_CHART_FEEDBACK_FORM_ID} />
    </ChartBottomWrapper>
  );
};

export default ChartBottom;
